import React from "react";
import { Button } from "antd";
import { MoveLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import "../Styles/Shared.scss";

interface BackButtonProps {
  label: string;
  to?: string;
}

const BackButton: React.FC<BackButtonProps> = ({ label, to }) => {
  const navigate = useNavigate();

  return (
    <Button
      className="competitive-back-button sla-back-button"
      onClick={() => (to ? navigate(to) : navigate(-1))}
    >
      <MoveLeft className="sla-back-button__icon" />
      {label}
    </Button>
  );
};

export default BackButton;
